import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export type BookingOrderingCohort = "book_first" | "screen_first" | "screen_last";

export function useBookingOrderingCohort(): BookingOrderingCohort {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_BOOKING_FLOW_ORDER, {
    defaultValue: "screen_first",
  });
}
